import React from 'react';
import { useTranslate } from 'react-admin';
import RecordTitleButton from '~/components/RecordTitleButton';
import { getHintEditModeColor, useEditMode } from '~/hooks/useEditModeContext';
import { useChangelog } from '~/hooks/useChangelogContext';
import ViewHistoryButton from './ViewHistoryButton';

const ChangelogModeNotice = () => {
  const { editMode } = useEditMode();
  const { exit } = useChangelog();

  const translate = useTranslate();
  const t = (key: string): string => translate(`components.Changelog.${key}`);

  if (editMode !== 'CHANGELOG') {
    return null;
  }

  return (
    <>
      <span style={{ color: getHintEditModeColor(editMode) }}>{t('warning')}</span>
      {t('view')}
      <RecordTitleButton label={t('current')} onClick={exit} />
      {'. '}
      <ViewHistoryButton />
    </>
  );
};

export default ChangelogModeNotice;
